import { Text } from '~/shared/components/Text/Text';
import { Container } from '../styled';
import { theme } from '~/theme';
import { TranslationKey } from '~/lib';

export const ForgotPasswordSubmittedView = ({
    translate,
}: {
    translate: (key: TranslationKey) => string;
}) => {
    return (
        <Container>
            <h4
                style={{ fontSize: theme.fontSizes.xl, textTransform: 'none' }}
                data-testid="forgot-password-submitted-headline"
            >
                {translate('login.needNewPassword')}
            </h4>

            <Text variant="bodySmall">{translate('login.youSubmittedWeWillSend')}</Text>
        </Container>
    );
};
